<template lang="pug">
  div.wall(:style="styWall()")
    button.tgl(@mousedown="mousedown",@touchstart="mousedown",:style="sty()")
      img(src="@/assets/ico_tb.svg")
      div.bln {{ Math.round(under) * 10 }}mm
    div.memo
</template>

<script>
export default {
  name: 'Vertical',
  components: {
  },
  data () {
    return {
      prev: 0,
      under: 0,
      flg: false,
      posX: 0,
      startX: 0,
      posY: 0,
      startY: 0,
      left: 0,
      bottom: 0
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    sty () {
      return {
        bottom: this.bottom + 'px'
      };
    },
    styWall () {
      return {
        left: (this.left + 70) + 'px'
      };
    },
    update () {
      if (this.sets[this.number] !== undefined) {
        this.set = this.sets[this.number];
        this.bottom = this.c2p(this.sets[this.number].size[3]);
        this.under = this.sets[this.number].size[3];
        this.left = this.c2p(this.set.left);
      }
    },
    mousedown (e) {
      let $tar = e.currentTarget;
      this.sY = parseInt($tar.style.bottom) || 0;
      this.startY = this.mp(e).clientY;
      this.flg = true;
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      let limit = 0;
      if (this.flg) {
        this.posY = this.startY - this.mp(e).clientY + this.sY;
        let ht = this.p2c(this.posY);
        // if (this.set.cat === 4) {
        //   limit = this.set.space[1] - this.set.slits[0].slit.pos - this.set.size[4];
        // } else {
        limit = this.set.space[1];
        // }
        if (ht < 0) {
          ht = 0;
        } else if (ht > limit) {
          ht = limit;
        }
        ht = Math.round(ht / 5) * 5;
        this.set.size[3] = ht;
        if (this.prev !== ht) {
          this.sets.splice(this.number, 1, this.set);
        }
        this.prev = ht;
      }
    },
    mouseup () {
      this.flg = false;
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchmove', this.mousemove);
      window.removeEventListener('touchend', this.mouseup);
    }
  },
  created () {
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .wall
    position absolute
    left 70px
    bottom 0
    z-index 2
    .tgl
      position absolute
      left 0
      bottom 0
      transform translate(-50%,50%)
      .bln
        position absolute
        left 50%
        top -70%
        transform translate(-50%,0)
        .preview &
          font-size 14px
      img
        pointer-events none

  .memo
    position absolute
    left -70px
    bottom 0
    width 50px
    height calc(50px/3 * 2)
    border-bottom 1px solid #000000
    border-left 1px solid #000000
    font-size 10px
    .preview &
      font-size 14px
    &:before
      content "150mm"
      position absolute
      left 50%
      bottom 0
      transform translate(-20%,0)
    &:after
      content "100mm"
      position absolute
      left -7px
      top 50%
      transform translate(0,-100%) rotate(-90deg)

</style>



// WEBPACK FOOTER //
// src/components/front/Vertical.vue